import { Component, Input, AfterViewInit } from '@angular/core';
import { Session } from 'app/modules/dashboard/models/activity.model';
import { NgFor, DatePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'tl-session-modal',
    styleUrls: ['./tl-sessions-modal.component.scss', '../ts-modal.component.scss'],
    template: `
    <body>
      <div class="header">
        <h2 translate>Sessions</h2>
      </div>

      <div class="content">
        <div id="count">
          <span>{{ sessions.length }}</span> sessions
        </div>

        <div
          class="session"
          *ngFor="let session of sessions; let index = index"
        >
          <div>
            <span>{{ index + 1 }}</span>
            <span class="data"
              ><span class="icon icon-timer"></span
              >{{  transformDuration(session.duration) }}</span
            >
            <span class="data"
              ><span class="icon icon-distance"></span
              >{{ transformDistance(session.distance) }}</span
            >
            <span class="data"
              ><span class="icon icon-watts"></span
              >{{ session.power.avg }}</span
            >
          </div>
          <span class="date">
            <span>{{session.created_at * 1000 | date : "dd/MM/yyyy"}}</span>
            <span>{{session.created_at * 1000 | date : "hh'h'mm"}}</span>
          </span>
        </div>
      </div>
    </body>
  `,
    standalone: true,
    imports: [
        TranslateModule,
        NgFor,
        DatePipe,
    ],
})
export class TrainingLogSessionModalComponent implements AfterViewInit {
  constructor() {}
  @Input() sessions: Session[];
  @Input() unit!: 'metric' | 'imperial';

  transformDuration(durationSec: number): string | null {
    if (isNaN(durationSec)) {
      return null;
    }
    const hours = Math.floor(durationSec / 3600);
    const minutes = Math.floor((durationSec % 3600) / 60);
    const seconds = Math.floor(durationSec % 60);
    return [
      hours.toString().padStart(2, '0'),
      minutes.toString().padStart(2, '0'),
      seconds.toString().padStart(2, '0')
    ].join(':');
  }


  /**
   * Transforme une distance en mètres en pieds ou en miles selon la distance et l'unité.
   * @param distance - Distance en mètres.
   * @param unit - Unité de mesure ('metric' ou 'imperial').
   * @returns La distance convertie sous forme de chaîne de caractères.
   */
  transformDistance(distance: number): string {
    const milesValue: number = 0.000621371; // 1 mètre en miles
    const feetValue: number = 3.28084; // 1 mètre en pieds
  
    if (Number.isNaN(distance)) {
      return 'distance is not a number';
    }

    if (this.unit === 'imperial') {
      // Si la distance est inférieure à 1 mile (1609.34 mètres), la convertir en pieds
      if (distance < 1609.34) {
        const distanceInFeet = distance * feetValue;
        return `${distanceInFeet.toFixed(2)} feet`;
      }
  
      // Si la distance est supérieure ou égale à 1 mile, la convertir en miles
      const distanceInMiles = distance * milesValue;
      return `${distanceInMiles.toFixed(2)} miles`;
    } else {
      // Pour l'unité métrique, afficher la distance en kilomètres
      return `${(distance / 1000).toFixed(3)} km`;
    }
  }


  ngAfterViewInit(): void {
    console.log(this.sessions);
  }
}
